export const LotusMark = ({ className = "", size = 34 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    fill="none"
    className={className}
    aria-hidden="true"
  >
    <circle cx="50" cy="50" r="46" stroke="url(#g)" strokeWidth="1.4" fill="none" opacity="0.9" />
    {/* silhouette back */}
    <path
      d="M50 22c5 0 8 3 9 8 1 6-1 11-1 16 0 6 3 10 3 15 0 4-4 7-11 7s-11-3-11-7c0-5 3-9 3-15 0-5-2-10-1-16 1-5 4-8 9-8z"
      stroke="url(#g)"
      strokeWidth="1.3"
      fill="none"
      opacity="0.85"
    />
    {/* lotus + hand */}
    <path
      d="M32 70c6 5 12 7 18 7s12-2 18-7"
      stroke="url(#g)"
      strokeWidth="1.4"
      fill="none"
    />
    <path
      d="M50 55c-4 6-10 9-16 9 2-6 7-11 16-13 9 2 14 7 16 13-6 0-12-3-16-9z"
      fill="url(#g)"
      opacity="0.9"
    />
    <defs>
      <linearGradient id="g" x1="0" y1="0" x2="100" y2="100" gradientUnits="userSpaceOnUse">
        <stop stopColor="#b98f47" />
        <stop offset="0.5" stopColor="#e6cf97" />
        <stop offset="1" stopColor="#b98f47" />
      </linearGradient>
    </defs>
  </svg>
);
